/**
 * パスワード忘れ
 */
 import * as httpConst from '../../../constants/httpConst'
 import Vue from 'vue'
 // import * as types from '../../mutation-types/driver-types'
 
  const API_PATH = `${httpConst.DRIVER_ENDPOINT}/recoveries`

  const recovery = {
    namespaced: true,
    actions: {
     index ({ commit }, { params }) {
       const api_path = `${API_PATH}/?login_id=${params}`
       return new Promise((resolve) => {
         Vue.$http.get(api_path).then(data => {
           resolve(data.content)
         })
       })
     },
   },
  }

  export default recovery
  
  
 